import React from 'react'
import _ from 'lodash'

class EventCarouselArrow extends React.PureComponent {
  getLabel() {
    return `${this.props.className.includes('prev') ? 'Previous' : 'Next'} event slide`
  }

  render() {

    return (
      <button
        { ...this.props }
        style={ this.style }
        className={ this.props.className + (this.props.hide ? ' hide' : '')}
        aria-label={ this.getLabel() }
      >
        <div className="focus-box"/>
      </button>
    )
  }
}

export default EventCarouselArrow;
